// extracted by mini-css-extract-plugin
export default {"border":"schedule_border__QAfUs","borderM":"schedule_borderM__D2Kf-"};